/* eslint-disable */
import { AfterViewInit, Component } from '@angular/core';
import { Transition, UIRouter } from '@uirouter/angular';
import { TranslateService } from '@ngx-translate/core';
import { DocumentLanguageItem, DocumentTextEditModel } from '../../../../util/document/document-utils';
import { Arrays } from '../../../../lib/util/arrays';
import { StringKey } from '../../../../app.string-keys';
import { EmptyMessage } from '../../../../lib/util/messages';
import { DocumentText, DocumentTextService } from '../../../../lib/document/document-text.service';
import { DocumentLanguageUtil } from '../../../../util/document/document-language-utils';
import { DocumentGroupService } from '../../../../lib/document/document-group.service';
import { DocumentGroupItem, LanguageItem } from '../../../../util/document/document-file-utils';
import { DocumentGroup } from '../../../../lib/document/document-group.service';
import { UiConstants } from '../../../../util/core-utils';
import { ResourceQueryResult } from '../../../../lib/util/services';
import { DocumentLanguageService } from '../../../../lib/document/document-language.service';
import { StateName } from '../../../../app.state-names';
/* eslint-enable */

@Component({
  selector: 'app-document-text-edit',
  templateUrl: 'document-text-edit.component.html',
  styleUrls: ['document-text-edit.component.scss'],
})
export class DocumentTextEditComponent implements AfterViewInit {

  languageItems: LanguageItem[] = [];
  documentId: number;
  model: DocumentTextEditModel;
  documentGroupList: DocumentGroupItem[] = [];
  documentLanguageList: DocumentLanguageItem[] = [];

  public options: Object = {
    placeholderText: '',
    charCounterCount: false,
    toolbarButtons: ['undo', 'redo' , '|', 'bold', 'italic', 'underline', 'strikeThrough', 'outdent', 'indent', 'clearFormatting'],
    quickInsertButtons: [],
    pluginsEnabled: []
  };

  constructor(
    private documentLanguageService: DocumentLanguageService,
    private documentLanguageUtil: DocumentLanguageUtil,
    private translateService: TranslateService,
    private documentGroupService: DocumentGroupService,
    private documentService: DocumentTextService,
    private uiRouter: UIRouter,
    private transition: Transition) {
    this.documentId = this.transition.params().id;
    this.model = new DocumentTextEditModel();
  }

  ngAfterViewInit(): void {
    this.loadModel();
  }

  private loadModel() {
    this.documentService.get({id: this.documentId})
      .subscribe(
      (documentText: DocumentText) => {
        const readModel = new DocumentTextEditModel();
        readModel.id = documentText.id;
        readModel.name = documentText.name;
        readModel.code = documentText.code;
        readModel.value = documentText.value;
        readModel.comment = documentText.comment;
        readModel.creation_time = documentText.creation_time;
        readModel.update_time = documentText.update_time;
        readModel.disabled = documentText.disabled;
        this.model = readModel;

        this.loadDocumentGroupList(documentText.document_group_id);
        this.loadLanguageCodes(documentText.language_code);
      }
    );
  }

  private loadLanguageCodes(language_code?: string) {
    this.documentLanguageService.query().subscribe( (result: string[]) => {
      const def = this.createDefaultLanguageCode();
      this.model.language_code = def;
      this.documentLanguageList.push(def);

      Arrays.iterateByIndex( result, language => {
        const languageItem = new DocumentLanguageItem();
        languageItem.id = language;
        languageItem.text = this.documentLanguageUtil.getDocumentLanguageName(language);

        if (languageItem.id === language_code) {
          this.model.language_code = languageItem;
        }
        this.documentLanguageList.push(languageItem);
      });
    });
  }

  private loadDocumentGroupList(groupId?: number) {
    this.documentGroupService.query({}).subscribe((result: ResourceQueryResult<DocumentGroup>) => {
      const def = this.createDefaultDocumentGroup();
      this.model.document_group = def;
      this.documentGroupList.push(def);
      Arrays.iterateByIndex(result.items, documentGroup => {
        const documentGroupItem = new DocumentGroupItem();
        documentGroupItem.id = documentGroup.id;
        documentGroupItem.text = documentGroup.name;
        if (documentGroup.id === groupId) {
          this.model.document_group = documentGroupItem;
        }
        this.documentGroupList.push(documentGroupItem);
      });
    });
  }

  private createDefaultDocumentGroup(): DocumentGroupItem {
    const def = new DocumentGroupItem();
    def.id = null;
    def.text = '';
    this.translateService.get(StringKey.COMMON_VALUE_UNSELECTED).subscribe(
      (text: string) => {
        def.text = text;
      }
    );
    return def;
  }

  private createDefaultLanguageCode(): LanguageItem {
    const def = new LanguageItem();
    def.id = null;
    def.text = '';
    this.translateService.get(StringKey.COMMON_VALUE_UNSELECTED).subscribe(
      (text: string) => {
        def.text = text;
      }
    );
    return def;
  }

  getTextMaximumLength(): number {
    return UiConstants.maximumVarcharLength;
  }

  update() {
    if (!this.model.id) {
      return;
    }

    const code = (this.model.code && this.model.code.length > 0) ? this.model.code : null;
    const languageCodeId = (this.model.language_code) ? this.model.language_code.id : null;
    const document_group_id = (this.model.document_group) ? this.model.document_group.id : null;

    this.documentService.update({
      id: this.model.id,
      name: this.model.name,
      code: code ? code : undefined,
      value: this.model.value,
      language_code: languageCodeId ? languageCodeId : undefined,
      document_group_id: document_group_id ? document_group_id : undefined,
      comment: this.model.comment

    }).subscribe(
      (response: EmptyMessage) => {
        this.uiRouter.stateService.go(StateName.DOCUMENT_TEXT_LIST);
      }
    );
  }

  back() {
    window.history.back();
  }
}
